import { render, staticRenderFns } from "./programBooking.vue?vue&type=template&id=133481fb&scoped=true"
import script from "./programBooking.vue?vue&type=script&lang=js"
export * from "./programBooking.vue?vue&type=script&lang=js"
import style0 from "./programBooking.vue?vue&type=style&index=0&id=133481fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133481fb",
  null
  
)

export default component.exports